import { SelectItem } from '@/_components';

export type ActivityLogType =
  | 'all'
  | 'detail_change'
  | 'document_related'
  | 'questionnaire_related'
  | 'review_and_export_related'
  | 'tax_return_delivery_related'
  | 'uncategorized';

export const ACTIVITY_LOG_CODES: Record<ActivityLogType, string> = {
  all: '',
  detail_change: '1',
  document_related: '2',
  questionnaire_related: '3',
  review_and_export_related: '6',
  tax_return_delivery_related: '5',
  uncategorized: '0',
};

const _ACTIVITY_LOG_LABELS: Record<ActivityLogType, string> = {
  all: 'All Activities',
  detail_change: 'Detail Change',
  document_related: 'Document Related',
  questionnaire_related: 'Questionnaire Related',
  review_and_export_related: 'Connect Related',
  tax_return_delivery_related: 'Delivery Related',
  uncategorized: 'Uncategorized',
};

export const ACTIVITY_LOG_COLORS: Record<string, string> = {
  '': 'gray',
  0: 'gray',
  1: 'gray',
  2: 'green',
  3: 'blue',
  5: 'blue',
  7: 'blue',
  4: 'orange',
  8: 'teal',
};

export const ACTIVITY_LOG_CODE_TO_TYPE = Object.entries(
  ACTIVITY_LOG_CODES,
).reduce<Record<string, ActivityLogType>>(
  (acc, [key, code]) => ({ ...acc, [code]: key as ActivityLogType }),
  {},
);

export const ACTIVITY_LOG_TYPE_BY_CODE = Object.entries(
  ACTIVITY_LOG_CODES,
).reduce<Record<string, ActivityLogType>>(
  (acc, [type, code]) => ({ ...acc, [code]: type as ActivityLogType }),
  {},
);

export const ACTIVITY_LOG_SELECT_OPTIONS: Array<SelectItem> = Object.entries(
  ACTIVITY_LOG_CODES,
).map(([type, code]) => ({
  name: _ACTIVITY_LOG_LABELS[type as ActivityLogType],
  value: code,
}));
